import "./styles/style.css";
import Nav from "./components/Nav";
import Homepage from "./pages/Homepage";
import WebDev from "./pages/WebDev";
import Discrete from "./pages/Discrete";
import Crypto from "./pages/Crypto";
import Python from "./pages/Python";
import ML from "./pages/ML";
import DataStructure from "./pages/DataStructure";
import LinearAlgebra from "./pages/LinearAlgebra";
import Page404 from "./pages/Page404";
import Info from "./pages/Info";
import { Switch, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Java from "./pages/Java";
import Android from "./pages/Android";
import DL from "./pages/DL";

const App = () => {
  // use location here.
  const location = useLocation();

  return (
    <div>
      <Nav />
      {/* <div style={{ overflow: "hidden" }}>
        <ReactCanvasNest
          className="canvasNest"
          config={{
            pointColor: " 255, 255, 255",
            lineColor: " 255, 255, 255",
            count: 80,
            pointR: 2,
            lineWidth: 8,
          }}
          style={{ zIndex: -1 }}
        /> */}

      <AnimatePresence exitBeforeEnter>
        <Switch location={location} key={location.pathname}>
          <Route path="/" exact>
            <Homepage />
          </Route>
          <Route path="/python" exact>
            <Python />
          </Route>
          <Route path="/ml" exact>
            <ML />
          </Route>
          <Route path="/dl" exact>
            <DL />
          </Route>
          <Route path="/webdev" exact>
            <WebDev />
          </Route>
          <Route path="/java" exact>
            <Java />
          </Route>
          <Route path="/android" exact>
            <Android />
          </Route>
          <Route path="/discrete" exact>
            <Discrete />
          </Route>
          <Route path="/crypto" exact>
            <Crypto />
          </Route>
          <Route path="/dataStructure" exact>
            <DataStructure />
          </Route>
          <Route path="/linearAlgebra" exact>
            <LinearAlgebra />
          </Route>
          <Route path="/info" exact>
            <Info />
          </Route>
          <Route path="/*">
            <Page404 />
          </Route>
        </Switch>
      </AnimatePresence>
    </div>
  );
};

export default App;
